import { P } from 'components'
import LihatDetail from 'components/Icons/LihatDetail'
import PMBBadge from 'components/PMBBadge'
import PMBPagination from 'components/PMBPagination'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useState } from 'react'
import { ChevronDown } from 'react-feather'
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap'
import { formatDatePMBV2 } from 'utils/formatDate'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import BatchDetailModal from './BatchDetailModal'

const TabHistory = ({
  dataHistory = [],
  totalItems = 0,
  isLoading = false,
  onViewDetail,
  currentPage = 0,
  rowsPerPage = 10,
  setCurrentPage,
  setRowsPerPage,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [detailBatch, setDetailBatch] = useState(null)

  const columns = [
    {
      name: <span>Batch ID</span>,
      wrap: true,
      grow: 2,
      cell: (row) => row?.batchName || '',
    },
    {
      name: <span>Date</span>,
      wrap: true,
      grow: 2,
      cell: (row) => formatDatePMBV2(row?.createdAt),
    },
    {
      name: <span>Recipients</span>,
      wrap: true,
      right: true,
      cell: (row) => row?.recipients || 0,
    },
    {
      name: <span>Total Transfers</span>,
      wrap: true,
      grow: 2,
      right: true,
      cell: (row) => `Rp${newFormatThousandSeparator(row?.total || 0, 2)}`,
    },
    {
      name: <span>Total + Fees</span>,
      wrap: true,
      grow: 2,
      right: true,
      cell: (row) =>
        `Rp${newFormatThousandSeparator(row?.totalPlusFee || 0, 2)}`,
    },
    {
      name: <span>Status</span>,
      wrap: true,
      grow: 2,
      center: true,
      cell: (row) => {
        const status = row?.status
        const statusLabel =
          status === 'ONPROGRESS' ? 'On Progress' : 'Completed'

        return (
          <>
            {status && (
              <PMBBadge
                variant={status === 'ONPROGRESS' ? 'warning' : 'verify'}
                title={statusLabel}
                className="px-2 w-auto"
                size="small"
              />
            )}
          </>
        )
      },
    },
    {
      name: '',
      wrap: true,
      width: '100px',
      right: true,
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center justify-content-end">
          <LihatDetail
            id={row?.id}
            onClick={() => {
              if (onViewDetail) {
                onViewDetail(row)
              } else {
                setIsOpen(true)
                setDetailBatch(row)
              }
            }}
          />
        </div>
      ),
    },
  ]

  const toggleClose = () => {
    setIsOpen((prev) => !prev)
    setDetailBatch(null)
  }

  return (
    <>
      <BatchDetailModal
        isOpen={isOpen}
        toggleClose={toggleClose}
        detailBatch={detailBatch}
      />

      <Card className="border-0 shadow-none">
        <CardBody>
          <div>
            <DataTable
              columns={columns}
              data={dataHistory || []}
              pagination
              paginationServer
              sortServer
              responsive
              persistTableHead
              progressPending={isLoading}
              progressComponent={
                <div style={{ margin: '100px 0px' }}>
                  <Spinner color="primary" />
                </div>
              }
              className="border p-0 border-1 rounded-top"
              noDataComponent={
                <p className="my-3 fw-semibold">
                  {!isLoading && 'No data has been registered yet'}
                </p>
              }
              sortIcon={<ChevronDown />}
              paginationComponent={(props) => (
                <PMBPagination
                  rowCount={totalItems || dataHistory?.length || 0}
                  currentPage={currentPage}
                  rowsPerPage={rowsPerPage}
                  setCurrentPage={setCurrentPage}
                  setRowsPerPage={setRowsPerPage}
                  props={props}
                />
              )}
            />
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default TabHistory
